{
  sports: allSports(
    orderBy: SPORT_LABEL_ASC
    condition: { limbo: false }
  ) {
    nodes {
      sportId
      sportName
      sportLabel
      limbo
      sportCoverageAvailablesBySportId {
        nodes {
          available
        }
      }
    }
  }
}
